<template>
  <v-card class="pa-2" flat>
    <v-card-text class="pa-0">
      <v-file-input
        ref="fileInput"
        v-model="filesModel"
        :error-messages="errors"
        :loading="loading"
        class="d-none"
        clear-icon="mdi-close-circle-outline"
        clearable
        dense
        hint="حداکثر حجم هر فایل مورد نظر می‌تواند 2 مگابایت باشد."
        label=" بارگذاری تصاوی"
        multiple
        outlined
        placeholder="لطفا لوگو لود شدن صفحه خودرابارگذاری کنید."
        prepend-icon=""
        prepend-inner-icon="mdi-camera"
        small-chips
        truncate-length="7"
        @change="handleFileUpload"
        @click:clear="filesModel = null"
      />
    </v-card-text>

    <v-card
      id="uploader"
      ref="uploader"
      :loading="loading"
      class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden"
      height="200"
      max-width="100%"
      outlined
      @click="dragEvent"
      @dragleave="dragEvent"
      @dragover="dragEvent"
      @drop="dragEvent"
    >
      <v-icon size="68" style="opacity: 0.4">mdi-cloud-upload-outline</v-icon>
      <v-card-title class="justify-center">آپلود فایل</v-card-title>
      <v-card-text class="text-center pt-0">
        برای آپلود بکشید و رها کنید یا
        <v-btn
          :loading="loading"
          class="mx-1"
          color="primary"
          min-width="75"
          small
        >
          اینجا
        </v-btn>
        کلیک کنید
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: "detectFileUploading_file",

  data: () => ({
    errors: "",
    filesModel: null,
    filesPreview: {},
    loading: false,
  }),

  methods: {
    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();

      let uploader = this.$refs.uploader;
      if (
        e.type === "dragover" &&
        !uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.add("drag-over");
      else if (
        e.type === "dragleave" &&
        uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.remove("drag-over");
      else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");

        const files = e.target.files || e.dataTransfer.files;
        this.handleFileUpload(files);
      } else if (e.type === "click") {
        this.$refs.fileInput.$refs.input.click();
      }
    },
    handleFileUpload(event) {
      let arr = Array.from(event);
      const allowedExtensions = ["pdf", "txt"];

      if (!!arr && !!arr.length) {
        let validFiles = arr.filter((file) => {
          const ext = file.name.split(".").pop().toLowerCase();
          return allowedExtensions.includes(ext);
        });

        if (validFiles.length !== arr.length) {
          this.$toast?.error(
            "فقط فایل‌های pdf، txt مجاز هستند.",
          );
        }

        this.$emit("change", {
          type: "file",
          files: validFiles,
        });
      }
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
#uploader {
  transition: all 0.3s ease;
  background-color: rgba(0, 0, 0, 0.2);
  border: 2px dashed #5b5b5b !important;
}

.drag-over {
  border: 2px dashed #fff !important;
  background-color: rgba(33, 150, 243, 0.33) !important;
}
</style>
